<template>
  <div>
    <v-autocomplete
      v-if="autocomplete"
      :label="label"
      no-data-text="Nenhuma opção disponível"
      :items="vendedores"
      item-value="codigo"
      item-text="nome"
      v-model="vendedorSelecModel"
      :loading="carregandoVendedores"
      :disabled="disabled"
      :auto-select-first="autoselectfirst"
      :hide-details="hideDetails"
      :dense="dense"
    ></v-autocomplete>
    <v-select
      v-else
      :label="label"
      no-data-text="Nenhuma opção disponível"
      :items="vendedores"
      item-value="codigo"
      item-text="nome"
      v-model="vendedorSelecModel"
      :loading="carregandoVendedores"
      :disabled="disabled"
      :dense="dense"
    ></v-select>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  props: {
    label: { type: String, default: "Representante/Vendedor" },
    disabled: { type: Boolean, default: false },
    autocomplete: { type: Boolean, default: false },
    autoselectfirst: { type: Boolean, default: false },
    hideDetails: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
  },
  watch: {
    vendedorSelecionado: function (value) {
      if (value == null) this.setVendedor(this.vendedores[0].codigo);
    },
  },
  computed: {
    ...mapState("base", ["vendedores", "carregandoVendedores"]),
    ...mapState("relatorios", ["vendedorSelecionado"]),
    vendedorSelecModel: {
      get: function () {
        return this.vendedorSelecionado;
      },
      set: function (value) {
        this.setVendedor(value);
      },
    },
  },
  methods: {
    ...mapMutations("relatorios", ["setVendedor"]),
    ...mapActions("base", ["getVendedores"]),
  },
  async mounted() {
    await this.getVendedores();
    this.setVendedor(this.vendedores[0].codigo);
  },
};
</script>

<style>
</style>